import shortid from 'shortid';
import { getImageInfoFromFile, getImageNaturalOrientation } from 'utils';

export const constructArtProductFromFile = async (imageFile) => {
  const { url, width: naturalWidth, height: naturalHeight } = await getImageInfoFromFile(imageFile);

  const customOptions = { crop: true };
  if (naturalWidth >= naturalHeight) {
    customOptions.maxHeight = 300;
  } else {
    customOptions.maxWidth = 300;
  }
  const {
    url: thumbnailUrl,
    width: thumbnailWidth,
    height: thumbnailHeight,
  } = await getImageInfoFromFile(imageFile, customOptions);

  return {
    id: shortid(),
    setName: '',
    name: '',
    tags: [],
    image: url,
    thumbnailImage: thumbnailUrl,
    fileName: imageFile.name,
    naturalWidth,
    naturalHeight,
    thumbnailWidth,
    thumbnailHeight,
    scale: 1,
    translateX: 0,
    translateY: 0,
    cropOrientation: getImageNaturalOrientation(naturalWidth, naturalHeight),
  };
};
